import React from "react";
import ThoughtChainsView from "./views/thoughts/ThoughtChainsView";
import TextView from "./views/TextView";
import { Block } from "@/interfaces/copilotTypes";
import { useTranslation } from "next-i18next";
import clsx from "clsx";
import Avatar from "@/components/Avatar";

interface Props {
	block: Block;
	avatar?: string;
	nickname?: string;
}

function MessageBlock({ block, avatar, nickname }: Props) {
	const { t } = useTranslation("copilot");
	return (
		<div
			className={clsx(
				"group flex max-w-full flex-col gap-2 p-4",
				block.role === "assistant" && "bg-white",
				block.role === "user" ? "text-[#000]" : "text-[#33007E]",
			)}
		>
			<div className="flex items-center">
				<Avatar src={avatar || ""} size="sm" />

				<div className="pl-2 text-sm font-bold">{nickname}</div>
			</div>

			<div>
				<div>
					{Array.isArray(block.thoughts) && block.thoughts?.length > 0 ? <ThoughtChainsView block={block} /> : null}
					{/* <AttachmentsView /> */}
					<TextView message={block.content} />

					{!block.content && <div className="text-sm font-medium">{t("thinking")}...</div>}
				</div>
				{/* <QuickReplies /> */}
			</div>

			{block.status == "pending" && (
				<div className="mt-2">
					<div className="typing__dot bg-slate-500"></div>
					<div className="typing__dot bg-slate-500"></div>
					<div className="typing__dot bg-slate-500"></div>
				</div>
			)}
		</div>
	);
}

export default MessageBlock;
